import { MULTIPLEADD, REMOVEITEM } from "./actionIdentifier";

export const multipleAdd = (id) => {
  return {
    type: MULTIPLEADD,
    payload: {
      id,
    },
  };
};

export const removeItem = (id) => {
  return {
    type: REMOVEITEM,
    payload: {
      id,
    },
  };
};
